import { Lead } from 'entities/Lead';
import { Note } from 'entities/Note';
import { User } from 'entities/User';

export interface NoteDrawerSchema {
  mode: Nullable<DrawerMode>;
  note?: Nullable<Note>;
  lead?: Nullable<Lead>;
  user?: Nullable<User>;
}

export enum DrawerMode {
  NOTE_EDIT = 'note_edit',
  NOTE_CREATE = 'note_create',
}
